export default __webpack_public_path__ + "static/media/doge.0d8a34b7.svg";